import React, {useEffect, useState} from 'react';
import logo from "../../logo.svg";
import NavLink from "../../components/Navigation/NavLink";
import {useLocation} from "react-router-dom";

const APP_URL = process.env.REACT_APP_APP_BASE_URL;
const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;
const ADMIN_URL = "/admin";

const AdminHeader = () => {
    const location = useLocation();

    const [headerMenu, setHeaderMenu] = useState([
        {
            href: `${ADMIN_URL}/brokers`,
            text: 'Brokers',
            additionalListClasses: ''
        },
        {
            href: `${ADMIN_URL}/vendors`,
            text: 'Vendors',
            additionalListClasses: ''
        },
        {
            href: `${ADMIN_URL}`,
            text: 'Admin',
            additionalListClasses: ''
        },
        {
            href: `${ADMIN_URL}/duplicate_accounts`,
            text: 'Duplicate Accounts',
            additionalListClasses: ''
        },
        {
            href: `${ADMIN_URL}/merged_accounts`,
            text: 'Merged Accounts',
            additionalListClasses: ''
        },
        {
            href: `${ADMIN_URL}/reports`,
            text: 'Reports',
            additionalListClasses: ''
        },
        {
            href: `${APP_BASE_URL}/account/logout`,
            text: 'Log out',
            additionalListClasses: 'sl-ml-auto'
        },
    ]);


    const changeActiveMenu = () => {
        setHeaderMenu(headerMenu.map((item) => {
            if (!item.href.includes('logout'))
                if (item.href === location.pathname) {
                    return {...item, additionalListClasses: 'sl-current-link'}
                } else {
                    return {...item, additionalListClasses: ''}
                }
            return item;
        }));
    };

    useEffect(() => {
            changeActiveMenu();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [location.pathname]);

    return (
        <header
            className="sl-header sl-border-bottom sl-bg-white sl-min-h-18 sl-flex sl-justify-center sl-gap-2-point-5 sl-items-center">
            <div className="sl-container">
                <div className="sl-row sl-flex sl-justify-between sl-items-center">

                    <a className="sl-col-span-2" href={APP_URL}>
                        <img src={logo}
                             alt="Shortlister Admin"
                             title="Shortlister Admin"
                             srcSet={logo}/>
                    </a>

                    <nav className="sl-col-span-5 sl-navbar sl-flex-1">
                        <ul className="sl-flex sl-gap-2">
                            {headerMenu.map((item, index) => (
                                <NavLink key={index} href={item.href} text={item.text}
                                         listClass={'sl-font sl-font-medium sl-text-md sl-py-8 sl-px-12 ' + item.additionalListClasses}
                                         linkClass={'sl-btn sl-btn-link-gray sl-text-gray-base sl-no-underline'}
                                />
                            ))}
                        </ul>
                    </nav>

                </div>
            </div>
        </header>
    );
};

export default AdminHeader;
